import * as React from 'react';
import * as autoBind from 'react-autobind';
import Header from '../Header/Header';
import Strings from '../../globals/Strings';
import DashboardButtonContainer from '../DashboardButton/DashboardButtonContainer';
import FeedbackUserService from '../../services/FeedbackUserService/FeedbackUserService';
import NotificationSettingsModel from '../../types/NotificationSettingsModel';
import {SlideToggle} from '@techsmith/tsc-cloud-style-guide';
import HeaderLogo from '../HeaderLogo/HeaderLogo';
import SettingsAndAccountWidget from '../SettingsAndAccountWidget/SettingsAndAccountWidget';
import Themeable from '../../types/Themeable';
import NotificationsClientPluginWrapperContainer from '../NotificationsClientPluginWrapper/NotificationsClientPluginWrapperContainer';
import UserMessaging from '../../utils/UserMessaging';

export default class Preferences extends React.Component<PreferenceProps, PreferenceState> {
   constructor(props: PreferenceProps) {
      super(props);
      autoBind(this);

      this.state = {isSettingCommentPreference: false, isSettingReplyPreference: false};
   }

   async onClickComment() {
      const {commentNotificationSettings, currentUserId} = this.props;
      this.setState({isSettingCommentPreference: true});

      try {
         const newNotificationSettings = Object.assign({}, commentNotificationSettings, {enabled: !commentNotificationSettings.enabled});
         await FeedbackUserService.postNotificationSettings(currentUserId, newNotificationSettings);
      } catch {
         UserMessaging.warn(Strings.errors.failedUpdatePreference);
      }

      this.setState({isSettingCommentPreference: false});
   }

   async onClickCommentReply() {
      const {replyNotificationSettings, currentUserId} = this.props;
      this.setState({isSettingReplyPreference: true});

      try {
         const newNotificationSettings = Object.assign({}, replyNotificationSettings, {enabled: !replyNotificationSettings.enabled});
         await FeedbackUserService.postNotificationSettings(currentUserId, newNotificationSettings);
      } catch {
         UserMessaging.warn(Strings.errors.failedUpdatePreference);
      }

      this.setState({isSettingReplyPreference: false});
   }

   render() {
      const {commentNotificationSettings, replyNotificationSettings} = this.props;
      const {isSettingCommentPreference, isSettingReplyPreference} = this.state;
      const headerLeft = <DashboardButtonContainer/>;
      const headerMiddle = <HeaderLogo linkToRoot={true}/>;
      const headerRight = <React.Fragment>
         <NotificationsClientPluginWrapperContainer/>
         <SettingsAndAccountWidget />
      </React.Fragment>;
      return (
         <div className="preferences">
            <Header leftSection={headerLeft} middleSection={headerMiddle} rightSection={headerRight}/>
            <div className="preferences-container">
               <div className="preference-section">
                  <div className="preference-header">{Strings.labels.preferences.notification.heading}</div>
                  <div className="preference">
                     <SlideToggle onClick={this.onClickComment} isChecked={commentNotificationSettings.enabled} labelText={Strings.labels.preferences.notification.commentAlerts} isDisabled={isSettingCommentPreference}/>
                     <div className="explanation">{Strings.labels.preferences.notification.commentExplanation}</div>
                  </div>
                  <div className="preference">
                     <SlideToggle onClick={this.onClickCommentReply} isChecked={replyNotificationSettings.enabled} labelText={Strings.labels.preferences.notification.replyAlerts} isDisabled={isSettingReplyPreference}/>
                     <div className="explanation">{Strings.labels.preferences.notification.replyExplanation}</div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

interface PreferenceProps extends Themeable {
   commentNotificationSettings: NotificationSettingsModel;
   replyNotificationSettings: NotificationSettingsModel;
   currentUserId: string;
}

interface PreferenceState {
   isSettingCommentPreference: boolean;
   isSettingReplyPreference: boolean;
}
